import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || '';

function NoticeCreate() {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  const [title, setTitle] = useState('');
  const [kind, setKind] = useState('all');
  const [important, setImportant] = useState(false);
  const [content, setContent] = useState('');
  const [saving, setSaving] = useState(false);

  // 선택/모달 상태
  const [selected, setSelected] = useState(null); // {_id,title,kind,important,createdAt}
  const [modalOpen, setModalOpen] = useState(false);
  const [acting, setActing] = useState(false);

  const fetchList = async () => {
    setLoading(true); setErr('');
    try {
      const res = await fetch(`${API_URL}/api/admin/notices`, { credentials: 'include' });
      const j = await res.json().catch(()=>({}));
      if (!res.ok || !j?.ok) throw new Error(j?.message || `불러오기 실패(${res.status})`);
      setList(Array.isArray(j.items) ? j.items : []);
    } catch (e) {
      setErr(e.message || '불러오기 실패');
      setList([]);
    }
    setLoading(false);
  };

  useEffect(() => { fetchList(); }, []);

  const resetForm = () => {
    setTitle('');
    setKind('all');
    setImportant(false);
    setContent('');
  };

  const handleCreate = async () => {
    if (!title.trim() || !content.trim()) {
      alert('제목과 내용을 입력하세요.');
      return;
    }
    setSaving(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/notices`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ title, content, kind, important })
      });
      const j = await res.json().catch(()=>({}));
      if (!res.ok || !j?.ok) {
        alert(j?.message || '등록 실패');
      } else {
        resetForm();
        await fetchList();
        alert('공지 등록이 완료되었습니다.');
      }
    } catch {
      alert('요청 실패');
    }
    setSaving(false);
  };

  const fmt = (ts) => ts ? new Date(ts).toLocaleString() : '';

  // 중요 토글
  const toggleImportant = async () => {
    if (!selected?._id) return;
    setActing(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/notices/${selected._id}/toggle-important`, {
        method: 'POST',
        credentials: 'include'
      });
      const j = await res.json().catch(()=>({}));
      if (!res.ok || !j?.ok) {
        alert(j?.message || '변경 실패');
      } else {
        await fetchList();
        setSelected(s => s ? { ...s, important: !!j.important } : s);
        alert(j.important ? '중요 공지로 설정되었습니다.' : '중요 공지가 해제되었습니다.');
      }
    } catch {
      alert('요청 실패');
    }
    setActing(false);
  };

  // 삭제
  const removeNotice = async () => {
    if (!selected?._id) return;
    if (!window.confirm('해당 공지를 삭제할까요? 복구할 수 없습니다.')) return;
    setActing(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/notices/${selected._id}`, {
        method: 'DELETE',
        credentials: 'include'
      });
      const j = await res.json().catch(()=>({}));
      if (!res.ok || !j?.ok) {
        alert(j?.message || '삭제 실패');
      } else {
        setModalOpen(false);
        setSelected(null);
        await fetchList();
      }
    } catch {
      alert('요청 실패');
    }
    setActing(false);
  };

  return (
    <div className="admin-page">
      <h1 className="admin-page__title">공지 만들기</h1>
      <button className="admin-page__back-button" type="button" onClick={() => navigate('/admin')}>목록으로</button>

      <div style={{ display:'flex', gap:24, alignItems:'flex-start', flexWrap:'wrap' }}>
        {/* 좌: 공지 리스트 */}
        <div style={{ width:480 }}>
          <h2 style={{ margin:'0 0 8px 0' }}>공지 리스트</h2>
          <div style={{ border:'3px solid #607d8b', borderRadius:8, padding:12, height:300, overflowY:'auto', background:'#fff' }}>
            {loading && <div>불러오는 중...</div>}
            {err && <div style={{ color:'#d33', marginBottom:8 }}>{err}</div>}
            {!loading && !err && list.length === 0 && <div>등록된 공지가 없습니다.</div>}
            {!loading && !err && list.length > 0 && (
              <ul style={{ listStyle:'none', padding:0, margin:0 }}>
                {list.map(n => (
                  <li
                    key={n._id}
                    onClick={() => { setSelected(n); setModalOpen(true); }}
                    style={{ padding:'8px 6px', borderBottom:'1px solid #f0f0f0', display:'flex', justifyContent:'space-between', gap:8, cursor:'pointer' }}
                  >
                    <div style={{ minWidth:0 }}>
                      <div style={{ fontWeight:700, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
                        {n.important ? '📌 ' : ''}{n.title}
                      </div>
                      <div style={{ fontSize:12, color:'#666' }}>
                        종류: {n.kind} · 등록: {fmt(n.createdAt)}
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        {/* 우: 공지 작성 폼 */}
        <div style={{ flex:1, minWidth:320, border:'3px solid #607d8b', borderRadius:8, padding:16, background:'#fff' }}>
          <h2 style={{ margin:'0 0 12px 0' }}>새 공지 작성</h2>

          <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
            <div>
              <div style={{ fontWeight:700, marginBottom:6 }}>제목</div>
              <input
                style={{ width:'100%', padding:'8px 10px', border:'1px solid #ccc', borderRadius:6 }}
                value={title}
                onChange={(e)=>setTitle(e.target.value)}
                placeholder="제목을 입력하세요"
                maxLength={200}
                disabled={saving}
              />
            </div>

            <div style={{ display:'flex', gap:16, alignItems:'center', flexWrap:'wrap' }}>
              <div>
                <div style={{ fontWeight:700, marginBottom:6 }}>종류</div>
                <select
                  value={kind}
                  onChange={(e)=>setKind(e.target.value)}
                  disabled={saving}
                  style={{ padding:'6px 8px' }}
                >
                  <option value="all">전체</option>
                  <option value="influencer">크리에이터</option>
                  <option value="marketer">광고주</option>
                </select>
              </div>

              <label style={{ display:'flex', alignItems:'center', gap:6 }}>
                <input type="checkbox" checked={important} onChange={(e)=>setImportant(e.target.checked)} disabled={saving} />
                중요 공지(상단 고정)
              </label>
            </div>

            <div>
              <div style={{ fontWeight:700, marginBottom:6 }}>내용</div>
              <textarea
                style={{ width:'100%', height:200, padding:'8px 10px', border:'1px solid #ccc', borderRadius:6, resize:'vertical' }}
                value={content}
                onChange={(e)=>setContent(e.target.value)}
                placeholder="공지 내용을 입력하세요"
                maxLength={10000}
                disabled={saving}
              />
            </div>

            <div>
              <button type="button" onClick={handleCreate} disabled={saving} style={{ background:'#26a69a', color:'#fff', padding:'10px 16px', borderRadius:8 }}>
                {saving ? '등록 중...' : '공지 등록'}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* 선택 공지 모달 */}
      {modalOpen && selected && (
        <div className="modal-background" onClick={() => setModalOpen(false)}>
          <div className="modal-content" onClick={(e)=>e.stopPropagation()} style={{ maxWidth:520 }}>
            <button className="modal-close-btn" onClick={() => setModalOpen(false)}>닫기</button>
            <h3 style={{ marginTop:0 }}>{selected.important ? '📌 ' : ''}{selected.title}</h3>
            <div style={{ color:'#666', marginBottom:12 }}>
              종류: {selected.kind} · 등록: {fmt(selected.createdAt)}
            </div>
            <div style={{ display:'flex', gap:8 }}>
              <button
                type="button"
                onClick={toggleImportant}
                disabled={acting}
                style={{ background:'#0277bd', color:'#fff' }}
              >
                {selected.important ? '중요 해제' : '중요 지정'}
              </button>
              <button
                type="button"
                onClick={removeNotice}
                disabled={acting}
                style={{ background:'#d32f2f', color:'#fff' }}
              >
                삭제
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default NoticeCreate;